import { get } from '../../../utils/http/get';
import { ENDPOINTS } from '../../endpoints';

export default async () => {
  const result = await get(ENDPOINTS.BACKEND_CONFIG);
  return result.body;
};
